import classNames from 'classnames';
import React from 'react';

import {BrowseCourse} from '@udemy/browse-course';
import {Academy} from '@udemy/career-academies';
import {ContentArea, ContentGrid, ContentGridItem} from '@udemy/react-layout-components';

import styles from './academy-curriculum-container.module.less';
import {AcademyCurriculum} from './academy-curriculum/academy-curriculum.react-component';

export interface AcademyCurriculumContainerProps {
    academy: Academy;
    courses?: BrowseCourse[];
}

export function AcademyCurriculumContainer(props: AcademyCurriculumContainerProps) {
    const {academy, courses} = props;

    if (!courses) {
        return null;
    }

    // Calculate the offset for the numbers next to the subject lines.
    // e.g, the first course should start with 1, but
    // the second course should start with 1 + the number of subjects in the first course.
    const subjectOffsets = courses.reduce(
        (acc, curr) => {
            return [...acc, acc[acc.length - 1] + academy.curriculum.subjects[curr.id]?.length];
        },
        [0],
    );

    return (
        <div
            className={classNames(
                'ud-full-viewport-container',
                styles['academy-curriculum-container-wrapper'],
            )}
        >
            <div className={styles['academy-curriculum-container']}>
                <ContentArea className={classNames('ud-container', styles.area)}>
                    <ContentGrid>
                        {courses.map((course, idx) => {
                            const curriculumSubjects = academy.curriculum.subjects[course.id];
                            if (curriculumSubjects) {
                                return (
                                    <ContentGridItem
                                        key={course.id}
                                        defaultColumn={'1 / span 4'}
                                        mdColumn={'1 / span 12'}
                                        lgColumn={'2 / span 10'}
                                    >
                                        <AcademyCurriculum
                                            index={idx}
                                            subjectOffset={subjectOffsets[idx]}
                                            course={course}
                                            curriculumSubjects={curriculumSubjects}
                                            title={academy.curriculum.summaries[course.id]?.title}
                                        />
                                    </ContentGridItem>
                                );
                            }
                            return null;
                        })}
                    </ContentGrid>
                </ContentArea>
            </div>
        </div>
    );
}
